import { render, staticRenderFns } from "./OrderAside.vue?vue&type=template&id=54663782&scoped=true&functional=true"
import script from "./OrderAside.vue?vue&type=script&lang=js"
export * from "./OrderAside.vue?vue&type=script&lang=js"
import style0 from "./OrderAside.vue?vue&type=style&index=0&id=54663782&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "54663782",
  null
  
)

export default component.exports